module.exports = __webpack_public_path__ + "static/img/profile.473f5971.jpg";